/**
 * Esquema de los campos de credenciales que declara cada integración en
 * attendance.integrations.Configuration, propiedad "fields". Los valores que se rellenan
 * se guardan en el contrato, en attendance.contracts.IntegrationConfig, indexados por "code".
 */
export type IntegrationFieldType = 'text' | 'password' | 'mail_account';

export interface IntegrationField {
  code: string;
  label: string;
  type: IntegrationFieldType;
  /** si viene, el campo se pinta dentro de un card con este nombre junto al resto de su grupo */
  group?: string;
}

/** Campos ya repartidos para pintar: los que no declaran grupo van con name a null y sin card. */
export interface IntegrationFieldGroup {
  name: string | null;
  fields: IntegrationField[];
}

/** Valor de un campo de tipo mail_account: una cuenta de correo completa. */
export interface MailAccountValue {
  /** arranca desactivada: hay que activarla a mano para que la integracion la use */
  enabled: boolean;
  email: string;
  /** el usuario de acceso al buzon no tiene por que coincidir con la direccion de correo */
  username: string;
  password: string;
  host: string;
  port: number | null;
  ssl: boolean;
}

export function emptyMailAccountValue(): MailAccountValue {
  return { enabled: false, email: '', username: '', password: '', host: '', port: 993, ssl: true };
}
